import { ActionTree } from 'vuex'
import RootState from './RootState'

const actions: ActionTree<RootState, RootState> = {}

export default actions
